module.exports = __webpack_public_path__ + "img/ladoricon.4652dbb0.png";